// src/utils/dateFormatter.js
// 日期格式化工具函数，从EventDetails中提取

/**
 * 格式化时间戳为用户友好的日期时间格式
 * @param {string} timestamp - ISO时间戳
 * @returns {string} 格式化后的日期时间
 */
export const formatDateTime = (timestamp) => {
  return new Date(timestamp).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * 格式化相对时间（如"2小时前"）
 * @param {string} timestamp - ISO时间戳
 * @returns {string} 相对时间描述
 */
export const formatRelativeTime = (timestamp) => {
  const now = new Date();
  const eventTime = new Date(timestamp);
  const diffMs = now.getTime() - eventTime.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMinutes < 1) {
    return "Just now";
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min ago`;
  } else if (diffHours < 24) {
    return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  } else if (diffDays < 7) {
    return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  } else {
    return formatDateTime(timestamp);
  }
};

/**
 * 获取严重级别对应的Badge变体
 * @param {string} severity - 严重级别 (mild, moderate, severe)
 * @returns {string} Badge组件的变体名称
 */
export const getSeverityVariant = (severity) => {
  switch (severity) {
    case 'mild': return 'flood-mild';
    case 'moderate': return 'flood-moderate';
    case 'severe': return 'flood-severe';
    default: return 'flood-normal';
  }
};

/**
 * 获取严重级别对应的图标
 * @param {string} severity - 严重级别
 * @returns {string} emoji图标
 */
export const getSeverityIcon = (severity) => {
  switch (severity) {
    case 'mild': return '🟡';
    case 'moderate': return '🟠';
    case 'severe': return '🔴';
    default: return '🔵';
  }
};

/**
 * 格式化严重级别文本
 * @param {string} severity - 严重级别
 * @returns {string} 格式化后的文本
 */
export const formatSeverity = (severity) => {
  return severity.charAt(0).toUpperCase() + severity.slice(1);
};